module.exports = __webpack_public_path__ + "static/media/btn_schrank.25577800.png";